<template>
    <div class="swiperList hml_whplt swiper-container">
        <div class="swiper-wrapper">
            <ul class="swiper-slide" :style="swiperStyle">
                <slot></slot>
            </ul>
        </div>
    </div>
</template>

<script>
import Swiper from "swiper";
import 'swiper/css/swiper.css';
import { createNamespacedHelpers } from "vuex";
let publicData = createNamespacedHelpers("publicData");
export default {
    data() { 
        return {
            swiper: null,
        }
    },
    mounted(){
        const _this = this;
        this.swiper = new Swiper('.swiperList',{
            direction: 'vertical',
            slidesPerView: 'auto',
            freeMode: true,
            on: {
                setTranslate(e){ // 这个方法监听滑动距离
                    if(_this.setSwiperNumFlag && e != 0){
                         // console.log(e);
                        _this.setSwiperNum(e);
                    }
                },
            },
        });
        if(this.setSwiperNumFlag && _this.swiperNum < -50){
            try {
                this.swiper.setTranslate(_this.swiperNum); // 这个方法让swiper滑动
            } catch (error) {
                this.swiper[this.swiper.length - 1].setTranslate(_this.swiperNum); // 这个方法让swiper滑动
            }
             
        }
        this.$emit("exportSwiper",this.swiper);
    },
    methods: {
        ...publicData.mapMutations(["setSwiperNum"])
    },
    beforeDestroy(){
        // this.setSwiperNum(0);
    },
    computed: {
        ...publicData.mapState(["swiperNum"])
    },
    props: {
        swiperStyle: {
            type: Object
        },
        setSwiperNumFlag: {
             type: Boolean,
             default: false
        }
    }
}
</script>

<style lang="scss" scoped>
.swiperList{
    position: absolute;
    .swiper-slide{
        width: 100%;
        height: auto;
        // max-height: 100%;
        position: relative;
    }
}
</style>